import http from '@/shared/api/http';
import type {DashboardHomeModel, ShareAppRequest} from '@/shared/features/dashboardHome/dashboardHome.model';

export const DashboardHomeApi = {
   get(): Promise<DashboardHomeModel> {
      return http.get('/dashboard/page/home');
   },

   shareApp(payload: ShareAppRequest): Promise<{message: string}> {
      return http.post('/dashboard/shares/app', payload);
   },
};
